import React from 'react';
import { TextInput } from '@paypalcorp/pp-react';

/**
 * Expiry date used for adding a card
 */

import PropTypes from 'prop-types';

import { cardSpecPropType } from 'prop-validators';
import { getFormattedExpirationDate } from './date-utils';

class Expiry extends React.Component {
  static propTypes = {
    cardSpec: cardSpecPropType,
    label: PropTypes.string.isRequired,
    helpText: PropTypes.string,
    errorMessage: PropTypes.string,
    handleChangeDate: PropTypes.func.isRequired,
    handleFocus: PropTypes.func,
    handleBlur: PropTypes.func,
    dir: PropTypes.string,
  };

  static defaultProps = {
    handleFocus: () => {},
    handleBlur: () => {},
  };

  state = {
    value: '',
    showIsRequiredError: false,
    lastCharacterIsSlash: false,
  };

  /**
   * Handle changing expiry date
   * Use the getFormattedExpirationDate util to format the date
   * @param {String} date - expiry date
   * @return {String} expiry - the formatted date
   */
  handleChangeDate = ({ target: { value: date } }) => {
    // if the new date is two digits and the previous date ended in a slash, we
    // should not add a slash when we format the date
    const shouldRemoveTrailingSlash =
      date.length === 2 && this.state.lastCharacterIsSlash;

    let expiry = getFormattedExpirationDate(date, {
      shouldRemoveTrailingSlash,
    });
    this.handleCheckForValue(date);
    this.props.handleChangeDate(expiry);

    this.setState({
      lastCharacterIsSlash: expiry.slice(-1) === '/',
      value: expiry,
    });

    return expiry;
  };

  /**
   * Check for a date value
   * If the field is required, we should show that this field needs a value
   * @param {String} date - expiry date
   */
  handleCheckForValue = (date) => {
    const { required = false } = this.props.cardSpec.fields.expirationDate;
    this.setState({ showIsRequiredError: required && !date });
  };

  /**
   * Call parent's handleFocus
   * @param {String} date - expiry date
   */
  handleFocus = ({ target: { value: date } }) => {
    this.props.handleFocus(date);
  };

  /**
   * Check for a date value and call parent's handleBlur
   * @param {String} date - expiry date
   */
  handleBlur = ({ target: { value: date } }) => {
    this.handleCheckForValue(date);
    this.props.handleBlur(date);
  };

  render() {
    const expirySpecs = this.props.cardSpec.fields.expirationDate;
    let { errorMessage } = this.props;

    return (
      <div style={{ margin: '10px 0 0', position: 'relative' }}>
        <TextInput
          type="tel"
          id="expiry"
          value={this.state.value}
          name="expiry"
          label={this.props.label}
          maxLength={expirySpecs.maxlength}
          pattern={expirySpecs.pattern}
          required={expirySpecs.required}
          helperText={this.props.helpText}
          onChange={this.handleChangeDate}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          errorText={errorMessage}
          dir={this.props.dir}
        />
      </div>
    );
  }
}

export default Expiry;
